import { Link } from "react-router-dom";
import { Mail } from "lucide-react";
import Logo from "@/components/brand/Logo";

const COLS = [
  { title: "Product", links: [["/#how", "How it works"], ["/#report", "The report"], ["/#pricing", "Pricing"], ["/signup", "Create account"]] },
  { title: "Company", links: [["/about", "About us"], ["/contact", "Contact us"]] },
  { title: "Legal", links: [["/privacy", "Privacy policy"], ["/terms", "Terms & conditions"]] },
];

export default function PublicFooter() {
  return (
    <footer className="relative bg-ds-plumdeep text-white" data-testid="public-footer">
      <div className="container-x relative py-16 grid gap-12 md:grid-cols-12">
        <div className="md:col-span-5 space-y-5">
          <Logo light />
          <p className="text-[15px] text-white/80 max-w-sm leading-relaxed">
            Career discovery for students in Classes 7 to 12. A class-specific exploration of interests and personality, with a guidance report written to be read together as a family.
          </p>
          <a href="mailto:support@campussaarthi.com" className="inline-flex items-center gap-2 text-sm text-white/90 hover:text-white" data-testid="footer-support-email">
            <Mail className="h-4 w-4" /> support@campussaarthi.com
          </a>
        </div>
        {COLS.map((col) => (
          <div key={col.title} className="md:col-span-2 space-y-4">
            <p className="eyebrow text-white/70">{col.title}</p>
            <ul className="space-y-2.5">
              {col.links.map(([to, label]) => (
                <li key={to}><Link to={to} className="text-sm text-white/85 hover:text-white link-underline" data-testid={`footer-link-${label.toLowerCase().replace(/[^a-z]+/g, "-")}`}>{label}</Link></li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="container-x relative border-t border-white/10 py-6 flex flex-col sm:flex-row justify-between gap-2 text-xs text-white/75">
        <p>&copy; {new Date().getFullYear()} Disha by CampusSaarthi powered by Unifygrove Technologies Pvt Ltd.</p>
      </div>
    </footer>
  );
}
